// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const ComplianceIcon = createSvgIcon(
  <svg width={24} height={24} fill="none" viewBox="0 0 24 24">
    <path
      stroke="currentColor"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="m11.1 16.57-1.92 5.25-1.4-3-3 1.4 2.19-6.02.3.19.81 1.35c.11.19.32.3.53.3l1.58.03zM16.77 14.2l2.2 6.01-3.01-1.4-1.4 3-1.91-5.24.9-.5 1.58-.02q.33-.02.53-.3l.8-1.36z"
      clipRule="evenodd"
    />
    <path
      stroke="currentColor"
      strokeLinejoin="round"
      strokeMiterlimit={2}
      strokeWidth={1.5}
      d="M11.87 16.92a1 1 0 0 1-.3-.08l-1.38-.77-1.58-.02a.6.6 0 0 1-.53-.3l-.8-1.36-1.36-.8a.6.6 0 0 1-.3-.54l-.02-1.58-.77-1.37a.6.6 0 0 1 0-.61L5.6 8.1l.02-1.57q0-.35.3-.53l1.36-.8.8-1.36c.11-.19.32-.3.53-.31l1.58-.02 1.37-.77a.6.6 0 0 1 .62 0l1.37.77 1.58.02c.21 0 .42.12.53.3l.8 1.36 1.36.8q.29.2.3.54l.02 1.57.77 1.38c.11.19.11.42 0 .61l-.77 1.37-.02 1.58q-.02.35-.3.53l-1.36.8-.8 1.36a.6.6 0 0 1-.53.3l-1.58.03-1.37.77q-.15.08-.31.08Z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={1.5}
      d="m9.75 10.13 1.52 1.52 2.97-2.96"
    />
  </svg>,
  "Compliance",
);
export default ComplianceIcon;
